/**
 * ProtectedRoute - Защита роутов для авторизованных пользователей
 *
 * Проверяет:
 * 1. Наличие токена в localStorage
 * 2. Валидность токена через /api/auth/profile
 * 3. Статус аккаунта (не заблокирован)
 *
 * Если нет авторизации — уводит на вход портала (returnUrl — эта страница)
 * Если аккаунт заблокирован — показывает сообщение
 */

import React from 'react';
import { useAccessCheck } from './useAccessCheck';
import AccessCheckError from './AccessCheckError';
import PortalLoginRedirect from './PortalLoginRedirect';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading, blocked, error, retry } = useAccessCheck();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
        color: '#8b949e'
      }}>
        Проверка авторизации...
      </div>
    );
  }

  if (error) return <AccessCheckError message={error} onRetry={retry} />;

  // Аккаунт заблокирован: вход портала здесь не поможет — показываем причину.
  if (blocked) {
    return (
      <section className="u2-card">
        <div className="u2-cardInner">
          <h1 className="u2-title" style={{ fontSize: 22 }}>Аккаунт заблокирован</h1>
          <p className="u2-subtitle">Обратитесь в поддержку.</p>
        </div>
      </section>
    );
  }

  // Не авторизован — на вход портала с возвратом на эту страницу
  if (!user) return <PortalLoginRedirect />;

  // Авторизован - показываем контент
  return <>{children}</>;
};

export default ProtectedRoute;
